import {
  FileExcelOutlined,
  ReloadOutlined,
  FolderOpenOutlined
} from "@ant-design/icons";
import {
  CommandBar,
  IContextualMenuItem,
  Persona,
  PersonaSize,
  SearchBox,
} from "@fluentui/react";
import React, { createContext, useContext, useEffect, useRef, useState } from "react";

import Moment from "react-moment";
import { Observer, observer } from "mobx-react-lite";

import { AgGridReact } from "ag-grid-react/lib/agGridReact";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import "ag-grid-enterprise";
import { Button, notification, Skeleton, Space, Tag } from "antd";

//   import "../../../styles/useraccounts.css";
import svg from "../img/request.svg";

import confirm from "antd/lib/modal/confirm";
import { toJS } from "mobx";
import { changeRequestStore } from "../store/ChangeRequestStore";
import { IChangeView } from "../types/interface";
import { SubPageHeaderTitle } from "../../../../../shared/SubPageHeaderTitle";
import ViewChangeRequest from "./dialog/ViewChangeRequest";
import ApproveRequestDialog from "./dialog/ApproveRequestDialog";
import DeclineRequestDialog from "./dialog/DeclineRequestDialog";
import { platformStore } from "../../../store/platformStore";
import { authStore } from "../../../../Home/store/AuthStore";

const _ = require("underscore");
const changeRequestStoreCtx = createContext(changeRequestStore);
const platformStoreCtx = createContext(platformStore);
const authStoreCtx = createContext(authStore);
type Props = {};

const ChangeRequestGrid = (props: Props) => {
  const ChangeRequestStore = useContext(changeRequestStoreCtx);
  const PlatformStore = useContext(platformStoreCtx);
  const AuthStore = useContext(authStoreCtx);
  const [isAppr, setIsAppr] = useState(false)
  const grid = useRef<AgGridReact>(null);

  // Determine if current user is SuperAdmin (groupId 3) or Admin (groupId 1)
  const userGroupId = AuthStore.currentUser.groups?.groupId;
  const isSuperAdmin = userGroupId === 3;
  const isAdmin = userGroupId === 1;

  // Filter requests based on role
  const getFilteredRequests = () => {
    const allRequests = [...ChangeRequestStore.changeRequests.values()];

    if (isSuperAdmin) {
      // SuperAdmin sees all requests
      return allRequests;
    } else {
      // Admin sees only SuperAdmin-approved requests
      return allRequests.filter(
        request => request.supperAdminApprovalStatus === "Approved"
      );
    }
  };

  // Helper function to check if action buttons (Approve/Decline) should be enabled
  const shouldEnableActionButtons = (): boolean => {
    const request = ChangeRequestStore.selectedChangeRequest;

    // No request selected
    if (_.isUndefined(request.changesRequestId)) {
      return false;
    }

    if (isSuperAdmin) {
      // SuperAdmin can act only on requests pending SuperAdmin approval
      return request.supperAdminApprovalStatus === "Pending";
    } else {
      // Admin can act only on requests pending Admin approval
      // (which means SuperAdmin already approved)
      return request.adminApprovalStatus === "Pending" &&
        request.supperAdminApprovalStatus === "Approved";
    }
  };

  useEffect(() => {
    async function loadRequests() {
      await ChangeRequestStore.getAllChangeRequest()
      await PlatformStore.getAllRank()
      await PlatformStore.getAllNationality()
      await PlatformStore.getAllBand()
      await PlatformStore.getAllBranch()
      await PlatformStore.getAllPrincipalBand()
      await PlatformStore.getAllProfession()
      await PlatformStore.getAllQualification()
      await PlatformStore.getAllNationality()
    }

    loadRequests();
  }, []);

  const rowSelected = (grid: any) => {
    const selrow = grid.api.getSelectedNodes()[0];
    // console.log(selrow)
    if (selrow) {
      const seldata = selrow.data as IChangeView;
      ChangeRequestStore.selectedChangeRequest = seldata;
      setIsAppr(true)
      // console.log("Seen data")
    } else {
      setIsAppr(false)
      ChangeRequestStore.selectedChangeRequest = {} as IChangeView;
      // console.log("Not Seen data")
    }
  };
  // let allUserGroupAsAString = (groupIds:string):string=>{
  //     let group:Array<number> = groupIds.split(",").map(x => Number(x))
  //     let groupNames:Array<string> = [];
  //     group.forEach((value: number, index: number)=>{
  //         let allGroup = AdminStore.allGroup.get(value);
  //       if(value === allGroup?.groupId){
  //         groupNames.push(allGroup?.name as string);
  //       }
  //     })
  //     return groupNames.join(", ")
  //   }

  const handlePermissionsOpen = () => { };
  const gridcolumnDefs = {
    columnDefs: [
      {
        rowDrag: true,
        valueGetter: function (params: any) {
          return Number(params.node.id) + 1;
        },
        width: 80,
        sortable: true,
        resizable: true,
        checkboxSelection: true,
      },
      {
        headerName: "FullName",
        field: "fullName",
        sortable: true,
        resizable: true,
        filter: true,

        cellRendererFramework: function (params: any) {
          return (
            <div>
              <Persona
                text={`${params.data.fullName}`}
                size={PersonaSize.size24}
                onRenderPrimaryText={(data: any) => {
                  return <span style={{ fontSize: "12px" }}>{data.text}</span>;
                }}
              />
            </div>
          );
        },
      },
      {
        headerName: "Gender",
        field: "gender",
        sortable: true,
        resizable: true,
        filter: true,
      },
      {
        headerName: "Branch",
        field: "branch",
        sortable: true,
        resizable: true,
        filter: true,
      },

      {
        headerName: "Changes Type",
        field: "changesType",
        sortable: true,
        resizable: true,
        filter: true
      },

      {
        headerName: "Fields Modified",
        field: "fieldsModified",
        sortable: true,
        resizable: true,
        width: 180,
        filter: true,
      },
      {
        headerName: "Supper Admin Status",
        field: "supperAdminApprovalStatus",
        sortable: true,
        resizable: true,
        width: 150,
        filter: true,
        cellRendererFramework: function (props: any) {
          const { supperAdminApprovalStatus } = props.data;
          return (
            <span title={supperAdminApprovalStatus}>
              {supperAdminApprovalStatus === "Approved" && <Tag color="#55af6cff">Approved</Tag>}
              {supperAdminApprovalStatus === "Pending" && <Tag color="#d89839ff">Pending</Tag>}
              {supperAdminApprovalStatus === "Declined" && <Tag color="#eb3110ff">Declined</Tag>}
            </span>
          );
        },
      },
      {
        headerName: "Admin Status",
        field: "adminApprovalStatus",
        sortable: true,
        resizable: true,
        width: 150,
        filter: true,
        cellRendererFramework: function (props: any) {
          const { adminApprovalStatus } = props.data;
          return (
            <span title={adminApprovalStatus}>
              {adminApprovalStatus === "Approved" && <Tag color="#55af6cff">Approved</Tag>}
              {adminApprovalStatus === "Pending" && <Tag color="#d89839ff">Pending</Tag>}
              {adminApprovalStatus === "Declined" && <Tag color="#eb3110ff">Declined</Tag>}
            </span>
          );
        },
      },
      {
        headerName: "SuperAdmin ",
        field: "supperAdminApprovedBy",
        sortable: true,
        resizable: true,
        width: 180,
        filter: true,
      },
      {
        headerName: "ApprovedOn",
        field: "supperAdminApprovedOn",
        sortable: true,
        resizable: true,
        width: 180,
        filter: true,
        cellRendererFramework: function (props: any) {
          const { supperAdminApprovedOn } = props.data;
          return (
            <span title={supperAdminApprovedOn}>
              {supperAdminApprovedOn && <Moment fromNow>{supperAdminApprovedOn}</Moment>}
            </span>
          );
        },
      },
      {
        headerName: "Admin",
        field: "adminApprovedBy",
        sortable: true,
        resizable: true,
        width: 180,
        filter: true,
      },
      {
        headerName: "ApprovedOn",
        field: "adminApprovedOn",
        sortable: true,
        resizable: true,
        width: 180,
        filter: true,
        cellRendererFramework: function (props: any) {
          const { adminApprovedOn } = props.data;
          return (
            <span title={adminApprovedOn}>
              {adminApprovedOn && <Moment fromNow>{adminApprovedOn}</Moment>}
            </span>
          );
        },
      },
      {
        headerName: "Request Date",
        field: "createdOn",
        sortable: true,
        resizable: true,
        width: 150,
        filter: true,
        cellRendererFramework: function (props: any) {
          const { createdOn } = props.data;
          return (
            <span title={createdOn}>
              {" "}
              {createdOn && <Moment fromNow>{createdOn}</Moment>}
            </span>
          );
        },
      },

    ],
  };
  return (
    <div className="ms-Grid" dir="ltr">
      <div className="ms-Grid-row">
        <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg8">
          <SubPageHeaderTitle
            count={ChangeRequestStore.changeRequests.size}
            title={"Members Information Update/Add Requests"}
          />
        </div>
        <div
          className="ms-Grid-col ms-sm12 ms-md4 ms-lg4"
          style={{ display: "flex", justifyContent: "flex-end" }}
        >
          <>
            <Space direction="horizontal">
              <Button
                shape="round"
                disabled={_.isUndefined(ChangeRequestStore.selectedChangeRequest.changesRequestId)}
                onClick={async () => {
                  ChangeRequestStore.showViewDialog = true;
                  ChangeRequestStore.setSelected()
                }}
              >
                View
              </Button>
              <Button
                style={{ backgroundColor: "#0078d4", borderColor: "#0078d4", color: shouldEnableActionButtons() ? "#fff" : "#51565aff" }}
                shape="round"
                disabled={!shouldEnableActionButtons()}
                onClick={async () => {
                  ChangeRequestStore.showApproveDialog = true;
                  ChangeRequestStore.setSelected()
                }}
              >
                Approve
              </Button>
              <Button
                type="primary"
                shape="round"
                disabled={!shouldEnableActionButtons()}
                onClick={() => {
                  ChangeRequestStore.showDeclineDialog = true;
                  ChangeRequestStore.setSelected()
                }}
              >
                Decline
              </Button>
            </Space>
          </>

        </div>
      </div>
      {ChangeRequestStore.changeRequests.size < 1 ? (
        <EmptyRequest />
      ) : (<>
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm12 commandbar">
            <CommandBar
              style={{}}
              items={[
                {
                  key: "refresh",
                  text: "Refresh",
                  name: "New",
                  onRenderIcon: () => <ReloadOutlined className="qicon" />,
                  onClick: (
                    ev?:
                      | React.MouseEvent<HTMLElement, globalThis.MouseEvent>
                      | React.KeyboardEvent<HTMLElement>
                      | undefined,
                    item?: IContextualMenuItem | undefined
                  ) => {
                    ChangeRequestStore.getAllChangeRequest();
                  },
                },

                {
                  key: "spacer1",
                  onRender: () => <div style={{ width: "300px" }} />,
                },
                {
                  key: "search",
                  onRender: () => (
                    <SearchBox
                      placeholder="Search"
                      styles={{
                        root: { width: "100%", borderBottomColor: "#CBD5E0" },
                      }}
                      underlined={true}
                      onChange={(
                        ev: React.ChangeEvent<HTMLInputElement> | undefined,
                        searchTerms: string | undefined
                      ) => {
                        //console.log("searchTerms", searchTerms);
                        if (searchTerms !== "") {
                          grid?.current?.api?.setQuickFilter(searchTerms!);
                        } else {
                          grid?.current?.api?.setQuickFilter("");
                        }

                        // const filterValue = grid.current.api.filterManager.quickFilter;
                      }}
                    ></SearchBox>
                  ),
                },
              ]}
              farItems={[
                {
                  key: "group4",
                  text: "Export to Excel",
                  name: "group",
                  onRenderIcon: () => <FileExcelOutlined className="qicon" />,

                  onClick: () => {
                    grid?.current?.api?.exportDataAsExcel();
                  },
                },
              ]}
            />
          </div>
        </div>
        <div className="ms-Grid-row" style={{ paddingTop: "10px" }}>
          {ChangeRequestStore.isLoading || ChangeRequestStore.approving ? (
            <>
              <Skeleton active />
              <Skeleton active />
              <Skeleton active />
              <Skeleton active />
              <Skeleton active />
            </>
          ) : (
            <div className="ms-Grid-col ms-sm12">
              {" "}
              <div
                className="ag-theme-balham"
                style={{
                  minHeight: "50vh",
                  height: "60vh",
                  width: "100%",
                  maxHeight: "80vh",
                }}
              >
                <Observer>
                  {() => (
                    <AgGridReact
                      rowData={getFilteredRequests().map((row) =>
                        toJS(row)
                      )}
                      ref={grid}
                      gridOptions={{
                        defaultColDef: {
                          sortable: true,
                          filter: true,
                        },
                        rowHeight: 30,
                        rowSelection: "single",
                        pagination: true,
                        columnDefs: gridcolumnDefs.columnDefs,
                        animateRows: true,
                        statusBar: {
                          statusPanels: [
                            {
                              statusPanel: "agTotalRowCountComponent",
                              align: "center",
                            },
                          ],
                        },
                      }}
                      rowSelection="single"
                      onSelectionChanged={rowSelected}
                      copyHeadersToClipboard={true}
                      overlayLoadingTemplate={`${(
                        <span className="ag-overlay-loading-center">
                          Please wait while your rows are loading
                        </span>
                      )}`}
                    ></AgGridReact>

                  )}
                </Observer>
              </div>
            </div>
          )}
        </div>

      </>)}
      {/* <EditStaffRequest/> */}
      <ViewChangeRequest />
      <ApproveRequestDialog />
      <DeclineRequestDialog />
    </div>
  );
};

const EmptyRequest = () => {
  return (
    <div className="ms-Grid" dir="ltr" style={{ marginTop: "140px" }}>
      <div className="ms-Grid-row">
        <div
          className="ms-Grid-col ms-sm12 ms-md12 ms-lg12"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            paddingTop: "20px",
          }}
        >
          <img src={svg} style={{ width: "35%" }} alt="No service" />
        </div>
        <div
          className="ms-Grid-col ms-sm12 ms-md12 ms-lg12"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <h2>No Member Update Request </h2>
        </div>
      </div>
    </div>
  );
};
export default observer(ChangeRequestGrid);
